import React, { Component } from 'react';
import './dashboard.css';
import $ from 'jquery';
import logo from './images/sd.png'
import './landing.css';
import { scroll } from './navbar'

export default class dashboard extends Component {
    constructor(props) {
        super(props);
        window.addEventListener('scroll', scroll, true);
    }
    componentDidMount = () => {
        this.myfunction();
    }

    componentDidUpdate = () => {
        this.myfunction();
    }
    myfunction = () => {
        

        $('#button').on('click', (event)=>{
           
            var form = document.forms[0]; // form element to be "readonly"
            [].slice.call(form.elements).forEach(function (item) {
                
                item.disabled = true;
                
            });
          });

        // selected checkbox data
        var selected = [],
            totalCheckboxes = $('.cbx-group').length;

        // select all
        $('#cbx-select-all').on('click', function () {
            $('.checkbox').prop('checked', $(this).prop('checked'));
            selected = getSelectedCheckbox();
            showSelected();
        })

        // select group
        $('.cbx-select-group').on('click', function () {
            var selectedGroup = $(this).val();
            $('.cbx-group-' + selectedGroup).prop('checked', $(this).prop('checked'));
            selected = getSelectedCheckbox();
            showSelected();
            checkAllState();
        })
        

        // select item
        $('[id^=cbx-group-]').on('click', function () {
            $(this).prop('checked', $(this).prop('checked'));
            selected = getSelectedCheckbox();
            showSelected();
            checkAllState();

            // update group selector check state
            var group = $(this).data('group')
            let totalGroupCheckbox = $('.cbx-group-' + group).length;
            let totalGroupSelected = $('.cbx-group-' + group + ':checked').length;
            if (totalGroupSelected == totalGroupCheckbox) {
                $('#cbx-select-group-' + group).prop('checked', true)
            } else {
                $('#cbx-select-group-' + group).prop('checked', false)
            }
        })
        $('#btnrt').on('click', function () 
        {
            console.log('hi');
            selected = getSelectedCheckbox();
            showSelected();
            update();
        })
        setInterval(function() {
            update();
            }, 1000);
        function update()
        {
            selected = getSelectedCheckbox();
            showSelected();
        }

        // update select-all check state
        function checkAllState() {
            var btn = $(".btn");
            if (selected.length != 0) {
                btn.removeClass('disableClick')
                console.log('hi');
            }
            else {
                btn.addClass('disableClick')
            }
            console.log('check all state')
            if ($('.cbx-group:checked').length == totalCheckboxes) {
                $('#cbx-select-all').prop('checked', true)
            } else {
                $('#cbx-select-all').prop('checked', false)
            }
        }

        // get all selected checkboxes data
        function getSelectedCheckbox() {
            var s = []
            $('.cbx-group:checked').each(function () {
                s.push($(this).data('id'));
            })
            return s;
        }

        function showSelected() {
            $('.output').text('')
            $(selected).each(function (i, v) {
                $('.output').append(v + ', ')
            })
        }
        $(function () {
            var btn = $(".btn");

            btn.on("click", function () {

                $(this).addClass('btn-progress');
                setTimeout(function () {
                    btn.addClass('btn-fill')
                }, 500);

                setTimeout(function () {
                    btn.removeClass('btn-fill')
                }, 4100);

                setTimeout(function () {
                    btn.addClass('btn-complete')
                }, 4100);

            });
        })



    }
    render() {
        return (
            <div>
                <div className="first-container">
                    <div className="nav-container">
                        <div className="nav-row">
                            <img src={logo} alt="logo" class="logo" />
                            <div className='Heading nav-logo'>Study Date </div>

                            <div className="nav-controls">
                                <a href="/#">Home</a>
                                <a href="/#about">About</a>
                                <a href="/#features">Features</a>
                                <a href="/">Logout</a>
                            </div>
                        </div>
                    </div>
                </div>
                <nav role="navigation">
                    <div id="menuToggle">

                        <input type="checkbox" />
                        <span></span>
                        <span></span>
                        <span></span>

                        <ul id="menu">
                            <li><a href="/#">Home</a></li>
                            <li><a href="/#about">About</a></li>
                            <li><a href="/#features">Features</a></li>
                            <li><a href="/">LogOut</a></li>
                        </ul>
                    </div>
                    <div className='Heading'>Study Date </div>
                    <img src={logo} alt="logo" class="logo" />
                </nav>
                <div class="container mt-5">

                    <div class="row">
                        <div class="col-6">

                            <form>
                                <h1 class="form-title">Select your Subject:</h1>
                                <div class="form-check mb-3 "><input class="form-check-input checkbox" id="cbx-select-all" type="checkbox" value="Group A 1" /><label class="form-check-label " for="cbx-select-all">Select ALL</label></div>
                                <div class="form-check"><input class="form-check-input checkbox cbx-select-group" id="cbx-select-group-a" type="checkbox" value="a" /><label class="form-check-label" for="cbx-select-group-a">Select Group A</label></div>
                                <fieldset class="form-group mb-3">
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-a" id="cbx-group-a-1" type="checkbox" value="Group A 1" data-group="a" data-id="SDF-1" /><label class="form-check-label" for="cbx-group-a-1">SDF-1</label></div>
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-a" id="cbx-group-a-2" type="checkbox" value="Group A 2" data-group="a" data-id="Economics" /><label class="form-check-label" for="cbx-group-a-2">Economics</label></div>
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-a" id="cbx-group-a-3" type="checkbox" value="Group A 3" data-group="a" data-id="Probability and Random Process" /><label class="form-check-label" for="cbx-group-a-3">Probability and Random Process</label></div>
                                </fieldset>
                                <div class="form-check"><input class="form-check-input checkbox cbx-select-group" id="cbx-select-group-b" type="checkbox" value="b" /><label class="form-check-label" for="cbx-select-group-b">Select Group B</label></div>
                                <fieldset class="form-group">
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-b" id="cbx-group-b-1" type="checkbox" value="Group B 1" data-group="b" data-id="SDF-2" /><label class="form-check-label" for="cbx-group-b-1">SDF-2</label></div>
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-b" id="cbx-group-b-2" type="checkbox" value="Group B 2" data-group="b" data-id="Data Structures" /><label class="form-check-label" for="cbx-group-b-2">Data structures</label></div>
                                    <div class="form-check"><input class="form-check-input checkbox cbx-group cbx-group-b" id="cbx-group-b-3" type="checkbox" value="Group B 3" data-group="b" data-id="Maths" /><label class="form-check-label" for="cbx-group-b-3">Maths</label></div>
                                </fieldset>
                                <div class="row">
                                    <a href="#show" class='btn disableClick' id="button" role="button" style={{ color: "#fb3569" }}>Submit</a>
                                    <input type="reset" id="btnrt" class='btn-reset' />
                                </div>
                            </form>

                        </div>

                        <div class="col-6">
                            <div class="p-3 bg-dark w-100 h-100 text-white">
                                <div class="font-weight-bold text-muted">Selected Topics:</div>
                                <div class="output">Nothing selected</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card formid" id="show">
                    <h1>Here is your meet link:</h1>
                    <a class="from-center" href='https://meet.google.com/pcg-aoop-ecu'>https://meet.google.com/pcg-aoop-ecu</a>
                </div>
            </div>
        );
    }

}